import platformApi from "@/api/platformApi";

const platformStore = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getPlatformInfo({ commit }, data) {
      return platformApi.getPlatformInfo(data);
    },
  },
};

export default platformStore;
